import BasicPage from './BasicPage';
import { BasicPageQuery } from './BasicPageQuery.graphql';

BasicPage.query = BasicPageQuery;

export default BasicPage;
